/* eslint-disable no-useless-return */
import { LogLevel } from '@azure/msal-browser';
import {
  MICROSOFT_TENANT_ID,
  MICROSOFT_CLIENT_ID,
  MICROSOFT_REDIRECT_URI
} from './constants';
import { globalConfig } from './globalConfig';

// Validation: Check if required Microsoft configuration values are present
// const MICROSOFT_TENANT_ID = globalConfig.getValue('tenant_id');
// const MICROSOFT_CLIENT_ID = globalConfig.getValue('client_id');

if (!MICROSOFT_TENANT_ID) {
  console.error('MICROSOFT_TENANT_ID is not defined');
}
if (!MICROSOFT_CLIENT_ID) {
  console.error('MICROSOFT_CLIENT_ID is not defined');
}
if (!MICROSOFT_REDIRECT_URI) {
  console.error('MICROSOFT_REDIRECT_URI is not defined');
}

// export const msalConfig = {
//   auth: {
//     clientId: `${MICROSOFT_CLIENT_ID}`,
//     authority: `https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}`,
//     redirectUri: `${MICROSOFT_REDIRECT_URI}`
//   },
//   cache: {
//     cacheLocation: 'localstorage',
//     storeAuthStateInCookie: true
//   }
// };

export const msalConfig = {
  auth: {
    clientId: `${MICROSOFT_CLIENT_ID}`,
    authority: `https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}`,
    redirectUri: MICROSOFT_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    // allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    },
    piiLoggingEnabled: false,
    logLevel: 'Verbose'
  }
};

export const tokenRequest = {
  scopes: [`api://${MICROSOFT_CLIENT_ID}/dev.odda`]
};